/**
 * Adoption Status Manager - Manages adoption status logic
 */
class AdoptionStatusManager {
  constructor() {
    this.statusIcon =
      '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/><path d="M12 8v4M12 16h.01" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }

  /**
   * @param {string} note - The note text
   * @returns {StatusInfo} Status info object
   */
  getStatusInfo(note) {
    const statusType = this._determineStatusType(note);
    return {
      type: statusType,
      icon: this.statusIcon,
    };
  }

  /**
   * @param {Filter} filter - Filter object
   * @param {Section} section - Section object
   * @param {string} note - Note text
   * @returns {any} Card object with HTML
   */
  createAdoptionCard(filter, section, note) {
    const statusInfo = this.getStatusInfo(note);
    const instructorName = section
      ? `${section.instructor_first_name || ''} ${
          section.instructor_last_name || ''
        }`.trim() || 'TBA'
      : 'TBA';
    const sectionNumber = section?.display_name || filter.selectedsection;

    return {
      statusType: statusInfo.type,
      html: `
        <div class="course-card adoption-card" data-status="${statusInfo.type}">
            <div class="course-header">
                <div class="header-content">
                    <div class="course-details">
                        <div class="course-title">${filter.selectedDepartment} ${filter.selectedcourse}</div>
                        <div class="section-info">Section: ${sectionNumber} | Instructor: ${instructorName}</div>
                    </div>
                    <div class="header-actions">
                        <button class="remove-btn" onclick="window.removeCourse(this)" 
                                data-department="${filter.selectedDepartment}" 
                                data-course="${filter.selectedcourse}" 
                                data-section="${filter.selectedsection}">
                            Remove
                            <svg class="remove-icon" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M13.5 4.5L4.5 13.5M4.5 4.5L13.5 13.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
            <div class="adoption-message-content">
                <div class="adoption-icon">${statusInfo.icon}</div>
                <p class="adoption-note">${note}</p>
            </div>
        </div>
      `,
    };
  }

  /**
   * @param {string} note - Note text
   * @returns {string} Status type
   */
  _determineStatusType(note) {
    const lowerNote = note.toLowerCase();

    if (lowerNote.includes('cancelled') || lowerNote.includes('cancel')) {
      return 'cancelled';
    }
    if (
      lowerNote.includes('open educational resources') ||
      lowerNote.includes('free')
    ) {
      return 'open-resources';
    }
    if (
      lowerNote.includes("aren't required") ||
      lowerNote.includes('not required')
    ) {
      return 'not-required';
    }
    if (
      lowerNote.includes('being finalized') ||
      lowerNote.includes('determined') ||
      lowerNote.includes('check back')
    ) {
      return 'pending';
    }

    return 'pending';
  }
}

window.ProductSystem = window.ProductSystem || {};
window.ProductSystem.AdoptionStatusManager = AdoptionStatusManager;
